import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import { websiteSchema, organizationSchema, homeFaqSchema } from '@/data/schema';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema()} />
      <JsonLd data={organizationSchema()} />
      <JsonLd data={homeFaqSchema()} />
      <Navbar />
      <main>
        <Hero />
        <AboutSection />
        <CategoryGrid />
        <ArticleSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}